var Marionette = require('backbone.marionette');
var template = require('./layout-template.hbs');

module.exports = Marionette.LayoutView.extend({
	el: 'body',
	template: template,
	regions: {
		header: '#header',
		main: '#main',
		footer: '#footer',
		overlay: '#overlay',
	},
	onRender: function () {
		// this.$el.parent().toggle(this.collection.length > 0);
		// this.updateFilterSelection();
	}
});
